// prettier-ignore
export const EMAIL_REGEXP = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

// prettier-ignore
export const FORUM_LINK = 'https://forum.dmarcian.com/?_gl=1*dzpplg*_gcl_au*ODg0NDM3MDkxLjE3MDU1NjU5NDE.&_ga=2.260986382.2092431107.1705650840-896258490.1705650840';

// prettier-ignore
export const HREF_REGEXP = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/g;

export const LOCAL_STORAGE_THEME = 'dmarc.io-theme';

export const API_URL = process.env.VITE_API_URL;
